export const replaceInvalidLinks = (
  obj,
  allContent: { __typename: string; items: [{ id: string; url: string }] }
) => {
  for (var key in obj) {
    if (obj[key] instanceof Object) {
      replaceInvalidLinks(obj[key], allContent)
    } else {
      if (obj[key] && obj[key].replace) {
        obj[key].replace(
          /\+[0-9]{2}\s*([0-9]+)?\s*([0-9]+)?\s*([0-9]+)?\s*([0-9]+)?/g,
          (match) => {
            obj[key] = obj[key].replace(
              match,
              `<a href='tel:${match}'>${match}</a>`
            )
          }
        )
      }

      if (obj[key] === '#') {
        const guid = obj['udi']
          ?.split('/')[3]
          ?.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5')

        const url = allContent.items.find((x) => x.id === guid)?.url ?? ''
        obj[key] = url
      }
      if (obj[key]?.toString().includes('href="#"')) {
        var dataIds = findAllAttributes(obj[key], 'data-id')

        // Replace each occurrence of 'href="#"' with the respective URL
        dataIds.forEach((dataId) => {
          var url = allContent.items.find((x) => x.id === dataId)?.url ?? ''

          // Use a more flexible regular expression to handle variations in attribute order
          obj[key] = obj[key].replace(
            new RegExp(
              `(data-id="${dataId}"\\s*href="\\s*#\\s*"|href="\\s*#\\s*data-id="${dataId}")`
            ),
            `data-id="${dataId}" href="${url}"`
          )
        })
      }
    }
  }
}
const findAllAttributes = (str, attr) => {
  const regex = new RegExp(`(${attr}=")([^"]*)`, 'g')
  const matches = str.match(regex)
  return matches ? matches.map((match) => match.split('"')[1]) : []
}

const findClosestAttribute = (str, attr) => {
  const regex = new RegExp(`(${attr}=")([^"]*)`, 'g')
  const match = regex.exec(str)
  return match ? match[2] : undefined
}
